import { render, staticRenderFns } from "./downloadPg.vue?vue&type=template&id=09a7ad65&scoped=true&"
import script from "./downloadPg.vue?vue&type=script&lang=js&"
export * from "./downloadPg.vue?vue&type=script&lang=js&"
import style0 from "./downloadPg.vue?vue&type=style&index=0&id=09a7ad65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a7ad65",
  null
  
)

export default component.exports